<script lang="ts" setup>
const model = defineModel<any>();

const emit = defineEmits([]);

function onNativeInput(e: Event): void
{
    emit("nativeInput", e);
}
</script>

<template>
    <textarea v-model="model" class="form-control" @input="onNativeInput"></textarea>
</template>
